import { render, staticRenderFns } from "./host-supply-company-info-new.vue?vue&type=template&id=4154b306&scoped=true&"
import script from "./host-supply-company-info-new.vue?vue&type=script&lang=js&"
export * from "./host-supply-company-info-new.vue?vue&type=script&lang=js&"
import style0 from "./host-supply-company-info-new.vue?vue&type=style&index=0&id=4154b306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154b306",
  null
  
)

export default component.exports